import { render } from "./stage-products.component.vue?vue&type=template&id=e6c3c4e6&scoped=true"
import script from "./stage-products.component.vue?vue&type=script&lang=js"
export * from "./stage-products.component.vue?vue&type=script&lang=js"

import "./stage-products.component.vue?vue&type=style&index=0&id=e6c3c4e6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6c3c4e6"]])

export default __exports__